/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import Form, {
  Label,
  StringLengthRule,
  RequiredRule,
  PatternRule,
  SimpleItem,
} from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import Button from "devextreme-react/button";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { ScrollView } from "devextreme-react/scroll-view";
import notify from "devextreme/ui/notify";
import { DateBox } from "devextreme-react";
import {
  responseMiddleware,
  responseTransaction,
  responseEmployee,
} from "../../../redux/reducers";
import {
  IsPermisionOidRequired,
  showTransactionAdjustment,
  getEmployeeByDeclarant,
} from "../../../redux/actions";
import "./style.scss";
import { useAuth } from "../../../contexts/auth";
import TransactionAdjustmentTableList from "./TransactionAdjustmentTable";
import { guidEmpty, validateRegexTimeString } from "../../../common";
import UsingIntl from "../../../services/using_intl";
import PopupConfig from "../../../common/popup";
import { useScreenSize } from "../../../utils/media-query";
import { axios } from "../../../common/axios";

const y = new Date().getFullYear(),
  m = new Date().getMonth();

export default function TransactionAdjustmentList() {
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useAuth();
  const { middleware, loading } = useSelector(responseMiddleware);
  const [isLoading, setIsLoading] = React.useState(false);
  const { transaction } = useSelector(responseTransaction);
  const { employeesDeclarant, loadingEmployee } = useSelector(responseEmployee);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const [employeeOid, setEmployeeOid] = useState(user?.EmployeeOid);
  const [filter, setFilter] = useState({
    Status: [0, 1, 2, 3, 4, 5],
    FromDate: new Date(y, m, 1).toLocaleDateString("en-CA"),
    ToDate: new Date(y, m + 1, 0).toLocaleDateString("en-CA"),
    EmployeeOid: employeeOid,
  });
  const [shift, setShift] = useState([]);

  const { isXSmall, isSmall } = useScreenSize();

  useEffect(() => {
    UsingIntl("P0044");
    dispatch(IsPermisionOidRequired());
  }, [dispatch]);

  const handleGetShift = async () => {
    const { data } = await axios.get(`Shift`, {
      headers: {
        MappedState: 1,
      },
    });
    setShift(data.value);
  };

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(getEmployeeByDeclarant(user?.EmployeeOid));
      handleGetShift();
    }
  }, [middleware]);

  const handleChangeSelectBox = async () => {
    const newPayload = {
      ...filter,
      Status: `${filter.Status}` === "null" ? null : `${filter.Status}`,
      EmployeeOid: employeeOid,
    };
    dispatch(showTransactionAdjustment(newPayload));
  };

  React.useEffect(() => {
    handleChangeSelectBox();
  }, [filter.Status]);

  const renderActions = ({ data }) => {
    const newData = {
      ...data,
      ShiftOid: data?.ShiftOid,
    };

    const isDiable = data?.TimeIn && data?.TimeOut ? true : false;
    return (
      <>
        {data?.RequestStatus === 0 || data?.RequestStatus === null && !isDiable ? (
          <Button
            type="default"
            disabled={isDiable}
            stylingMode="outlined"
            icon="edit"
            onClick={() => {
              handleOpenPopup(newData);
            }}
            className="button-rounded mr-2"
          />
        ) : null}
      </>
    );
  };
  const handleSubmitPopup = async () => {
    if (
      (!popupConfig.data.AdjustmentTimeIn &&
        !popupConfig.data.AdjustmentTimeOut) ||
      !popupConfig.data.Explain ||
      popupConfig.data.ShiftOid === guidEmpty
    ) {
      notify("Vui lòng nhập đủ dữ liệu", "error");
      return;
    }
    const regexAdjustmentTimeIn = validateRegexTimeString(
      popupConfig.data.AdjustmentTimeIn
    );
    const regexAdjustmentTimeOut = validateRegexTimeString(
      popupConfig.data.AdjustmentTimeOut
    );

    if (
      (popupConfig.data.AdjustmentTimeIn && !regexAdjustmentTimeIn) ||
      (popupConfig.data.AdjustmentTimeOut && !regexAdjustmentTimeOut)
    ) {
      notify("Nhập chưa đúng định dạng hh:mm:ss", "warning", 3000);
      return;
    }

    try {
      const newEmp = { Oid: popupConfig.data.EmployeeOid };
      const payload = {
        Date: popupConfig.data.WorkingDay,
        AdjustmentTimeIn: popupConfig.data.AdjustmentTimeIn,
        AdjustmentTimeOut: popupConfig.data.AdjustmentTimeOut,
        AdjustmentReason: 40,
        Explain: popupConfig.data.Explain,
        Employee: newEmp,
        Oid: popupConfig.data.Oid,
        ShiftOid: popupConfig.data.ShiftOid,

        TimeIn: popupConfig.data.TimeIn,
        TimeOut: popupConfig.data.TimeOut,
      };
      await axios.post(`AdjustTransaction`, payload, {
        headers: {
          MappedState: 3,
        },
      });

      // dispatch(putTransactionAdjustment(payload));
      handleClosePopup();
      handleChangeSelectBox();
      notify("Edit Success", "success", 3000);
      dataGrid.current.instance.refresh();
      // // close popup
      // dataGrid.current.instance.cancelEditData();
    } catch (error) {
      handleChangeSelectBox();
      notify(
        error.response.data.message ?? "Somethings went wrong",
        error.response.data.msgType ?? "error",
        3000
      );
    }
  };

  const renderPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        width={isSmall || isXSmall ? "100%" : "650px"}
        height={isSmall || isXSmall ? "400px" : "550px"}
        title={formatMessage("Transaction Adjustment")}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <ScrollView width="100%" height="100%">
          <Form formData={popupConfig.data}>
            <Item itemType="group" colCount={2} colSpan={2}>
              <Item
                dataField="WorkingDay"
                colCount={2}
                colSpan={2}
                editorOptions={{
                  disabled: true,

                  // date format
                }}
              >
                <DateBox
                  defaultValue={popupConfig.data.WorkingDay}
                  showClearButton={true}
                  useMaskBehavior={true}
                  disabled={true}
                  displayFormat="dd/MM/yyyy"
                />
                <Label text={formatMessage("WorkingDay")} />
              </Item>
              {/* <Item
                dataField="Shift"
                editorOptions={{
                  disabled: true,
                }}
              >
                <Label text={formatMessage("Shift")} />
              </Item> */}
              <Item
                dataField="ShiftOid"
                editorType="dxSelectBox"
                colCount={2}
                colSpan={2}
                editorOptions={{
                  items: shift,
                  displayExpr: (item) => {
                    return item && `${item.Code} - ${item.Name}`;
                  },
                  valueExpr: "Oid",
                }}
              >
                <RequiredRule />
                <StringLengthRule max="250" />
                <Label text={formatMessage("Shift")} />
              </Item>
              <Item
                dataField="ShiftTimeIn"
                editorOptions={{
                  disabled: true,
                }}
              >
                <Label text={formatMessage("ShiftTimeIn")} />
              </Item>
              <Item
                dataField="ShiftTimeOut"
                editorOptions={{
                  disabled: true,
                }}
              >
                <Label text={formatMessage("ShiftTimeOut")} />
              </Item>
              <Item
                dataField="TimeIn"
                editorOptions={{
                  disabled: true,
                }}
              >
                <Label text={formatMessage("TimeIn")} />
              </Item>
              <Item
                dataField="TimeOut"
                editorOptions={{
                  disabled: true,
                }}
              >
                <Label text={formatMessage("TimeOut")} />
              </Item>
              <SimpleItem
                dataField="AdjustmentTimeIn"
                editorOptions={{
                  mask: "00:00:00",
                  useMaskedValue: true,
                  disabled: popupConfig?.data?.TimeIn ? true : false,
                  maskRules: {
                    H: /[0-2]/,
                    h: /[0-9]/,
                    M: /[0-5]/,
                    m: /[0-9]/,
                    S: /[0-5]/,
                    s: /[0-9]/,
                  },
                }}
              >
                <StringLengthRule max="100" />
                <PatternRule
                  message="Nhập chưa đúng định dạng hh:mm:ss"
                  pattern={/^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/}
                />
                <RequiredRule />
                <Label text={formatMessage("AdjustmentTimeIn")} />
              </SimpleItem>
              {/* format Hh:mm:ss */}
              <SimpleItem
                dataField="AdjustmentTimeOut"
                editorOptions={{
                  mask: "00:00:00",
                  disabled: popupConfig?.data?.TimeOut ? true : false,
                  useMaskedValue: true,
                  // time format
                  maskRules: {
                    H: /[0-2]/,
                    h: /[0-9]/,
                    M: /[0-5]/,
                    m: /[0-9]/,
                    S: /[0-5]/,
                    s: /[0-9]/,
                  },
                  maskInvalidMessage: "Nhập chưa đúng định dạng hh:mm:ss",
                }}
              >
                <StringLengthRule max="100" />
                <RequiredRule />
                <PatternRule
                  message="Nhập chưa đúng định dạng hh:mm:ss"
                  pattern={/^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/}
                />
                <Label text={formatMessage("AdjustmentTimeOut")} />
              </SimpleItem>
              {/* <Item
                dataField="AdjustmentReason"
                colCount={2}
                colSpan={2}
                editorType="dxSelectBox"
                editorOptions={{
                  items: TransactionAdjustmentReason,
                  displayExpr: changeDisplayedName(),
                  valueExpr: "id",
                }}
              >
                <RequiredRule />
                <StringLengthRule max="250" />
                <Label text={formatMessage("AdjustmentReason")} />
              </Item> */}
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField="Explain" editorType="dxTextArea" colSpan={2}>
                  <Label text={formatMessage("Explain")} />
                  <RequiredRule />
                </Item>
              </Item>
            </Item>
          </Form>
        </ScrollView>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          disabled={(popupConfig?.data?.TimeOut && popupConfig?.data?.TimeIn) ? true : false}
          location="after"
          onClick={handleSubmitPopup}
          options={{
            icon: "save",
            type: "default",
            text: formatMessage("Save"),
            width: "200px",
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      {isLoading && <LoadPanel visible={isLoading} />}
      {loadingEmployee && <LoadPanel visible={loadingEmployee} />}
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("Transaction Adjustment")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>
            {formatMessage("Transaction Adjustment")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderPopup()}
          <TransactionAdjustmentTableList
            dataGrid={dataGrid}
            middleware={middleware}
            handleChangeSelectBox={handleChangeSelectBox}
            filter={filter}
            setFilter={setFilter}
            dataSource={transaction}
            renderActions={renderActions}
            employeeOid={employeeOid}
            setEmployeeOid={setEmployeeOid}
            user={user}
            employee={employeesDeclarant}
            setIsLoading={setIsLoading}
          />
        </div>
      </div>
    </div>
  );
}
